import React from 'react';
import '../../../../Context/index.js';
import cx from 'classnames';
import { Thumb } from './Thumb/index.js';
import { ThumbCollection } from './ThumbCollection/index.js';
import { LinkCollectionV2 } from '../LinkCollectionV2/index.js';
import { VipLink } from '../VipLink/index.js';
import styles from './index.module.scss.js';
import { useLayoutContext } from '../../../../Context/utils/useLayoutContext.js';

const RenderCollapsedMenu = ({ menu, noBorder, ...props }) => {
  const {
    menuExpandedLinkCollection,
    setMenuExpandedLinkCollection,
    setIsAsideMenuOpen
  } = useLayoutContext();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, {
        [styles["no-border"]]: noBorder
      })
    },
    menu.map(({ key, ...innerProps }) => {
      if (innerProps.kind === "linkCollection") {
        return /* @__PURE__ */ React.createElement(
          ThumbCollection,
          {
            key,
            name: innerProps.name,
            links: innerProps.links,
            icon: innerProps.icon,
            onExpand: (isExpanded) => {
              setMenuExpandedLinkCollection(
                isExpanded ? innerProps.name : ""
              );
            },
            isExpanded: menuExpandedLinkCollection === innerProps.name
          }
        );
      }
      if (innerProps.kind === "tabLinkCollection") {
        return /* @__PURE__ */ React.createElement(
          LinkCollectionV2,
          {
            ...innerProps,
            key,
            small: true,
            onExpand: (isExpanded) => {
              setMenuExpandedLinkCollection(
                isExpanded ? innerProps.name : ""
              );
            }
          }
        );
      }
      if (innerProps.kind === "thumbLink") {
        return /* @__PURE__ */ React.createElement(
          Thumb,
          {
            key,
            kind: "pure",
            name: innerProps.name,
            href: innerProps.href,
            icon: innerProps.icon,
            target: innerProps.target,
            onClick: innerProps.onClick
          }
        );
      }
      if (innerProps.kind === "link") {
        return /* @__PURE__ */ React.createElement(
          Thumb,
          {
            key,
            kind: "pure",
            name: innerProps.name,
            href: innerProps.href,
            icon: innerProps.icon,
            target: innerProps.target,
            onClick: innerProps.onClick,
            isActive: innerProps.isActive
          }
        );
      }
      if (innerProps.kind === "node") {
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            onClick: () => {
              setIsAsideMenuOpen(true);
              setMenuExpandedLinkCollection(innerProps.name);
            },
            key
          },
          /* @__PURE__ */ React.createElement(
            ThumbCollection,
            {
              key,
              name: innerProps.name,
              links: [],
              icon: innerProps.icon
            }
          )
        );
      }
      if (innerProps.kind === "vip") {
        return /* @__PURE__ */ React.createElement(VipLink, { small: true, key, ...innerProps });
      }
      return null;
    })
  );
};

export { RenderCollapsedMenu };
//# sourceMappingURL=index.js.map
